





























































































































import {
  Component,
  Prop,
  Vue, Watch,
} from 'vue-property-decorator';
import EventBus from '@/services/eventbus.service';
import JobsService from '@/services/jobs.service';
import {Getter, Mutation, Action} from 'vuex-class';
import {Job} from '@/types';

@Component
export default class JobMenu extends Vue {
  @Prop() private openMenu!: boolean;
  @Mutation private clearJobs: any;
  @Mutation private removeCompletedJobs: any;
  @Mutation private addActiveJob: any;
  @Mutation private addCompletedJob: any;
  @Mutation private cancelJob: any;
  @Getter private activeAccountId!: any;
  @Getter private activeJobs: any;
  @Getter private hasPermission: any;
  @Getter private completedJobs: any;
  @Getter private activeOrganisationId: any;

  private poller: any = null;
  private moveUp: number = -46;
  private isAdmin: boolean = false;
  private isAccount: boolean = false;

  @Watch('activeOrganisationId')
  private onOrgChange() {
    this.clearJobs();
  }

  @Watch('openMenu')
  private onMenuOpen() {
    if (this.openMenu) {
      if (this.poller) {
        clearInterval(this.poller);
      }
      if (!this.isAdmin) {
        if (!this.isAccount) {
          this.poller = setInterval(this.pollJobData.bind(this), 1000);
        } else {
          this.poller = setInterval(this.pollAccountJobData.bind(this), 1000);
        }
      } else {
        this.poller = setInterval(this.pollAdminJobData.bind(this), 1000);
      }
    } else {
      clearInterval(this.poller);
      this.poller = null;
      this.moveUp = -46;
    }
  }

  private mounted() {
    (window as any).EventBus = EventBus;
    EventBus.$on('jobCreated', this.startJobNotification);
    EventBus.$on('adminJobCreated', this.startAdminJobNotification);
    EventBus.$on('accountJobCreated', this.startAccountJobNotification);
  }

  private beforeDestroy() {
    EventBus.$off('jobCreated', this.startJobNotification);
    EventBus.$off('adminJobCreated', this.startAdminJobNotification);
    EventBus.$off('accountJobCreated', this.startAccountJobNotification);
  }

  private async startJobNotification(id: string) {
    this.isAdmin = false;
    this.isAccount = false;
    const job = await JobsService.pollJob(id);
    const newJob = {jobId: id, pollData: job};
    this.addActiveJob(newJob);
    if (this.activeJobs.length > 1) {
      this.moveUp += 66;
    }
    this.getCurrentJobValue(newJob);
    this.$emit('open');
  }

  private async startAccountJobNotification(id: string) {
    this.isAdmin = false;
    this.isAccount = true;
    const job = await JobsService.pollAccountJob(this.activeAccountId, id);
    const newJob = {jobId: id, pollData: job};
    this.addActiveJob(newJob);
    if (this.activeJobs.length > 1) {
      this.moveUp += 66;
    }
    this.getCurrentJobValue(newJob);
    this.$emit('open');
  }

  private async startAdminJobNotification(id: string, admin: boolean = false) {
    this.isAdmin = true;
    this.isAccount = false;
    const job = await JobsService.pollAdminJob(id);

    const newJob = {jobId: id, pollData: job};
    this.addActiveJob(newJob);
    if (this.activeJobs.length > 1) {
      this.moveUp += 66;
    }
    this.getCurrentJobValue(newJob);
    this.$emit('open');
  }

  private pollJobData(): void {
    this.activeJobs.forEach(async (report: any) => {
      try {
        if (!report.pollData.type.startsWith('admin')) {
          const job = await JobsService.pollJob(report.jobId);
          const currJob = {jobId: report.jobId, pollData: job};
          this.getCurrentJobValue(currJob);
          report.pollData = job;
          if (job.status === 'completed' || job.status === 'failed') {
            this.addCompletedJob(currJob);

            if (job.type.startsWith('device')) {
              if (this.hasPermission('device:read')) {
                EventBus.$emit('DevicesTable:LoadDevices');
              } else if (this.hasPermission('inventory:read')) {
                EventBus.$emit('InventoryDevicesTable:LoadDevices');
              }
            }
          }
        }
      } catch (e) {
        this.cancelJob(report.jobId);
        throw e;
      }
    });
  }

  private pollAccountJobData(): void {
    this.activeJobs.forEach(async (report: any) => {
      try {
        if (!this.activeAccountId) {
          return;
        }
        const job = await JobsService.pollAccountJob(this.activeAccountId, report.jobId);
        const currJob = {jobId: report.jobId, pollData: job};
        this.getCurrentJobValue(currJob);
        report.pollData = job;
        if (job.status === 'completed' || job.status === 'failed') {
            this.addCompletedJob(currJob);

            if (job.type.startsWith('device')) {
            if (this.hasPermission('device:read')) {
              EventBus.$emit('DevicesTable:LoadDevices');
            } else if (this.hasPermission('inventory:read')) {
              EventBus.$emit('InventoryDevicesTable:LoadDevices');
            }
          }
            if (job.type.startsWith('subscriptions')) {
            EventBus.$emit('AccountSubscriptionsTable:LoadSubscriptions');
          }
        }
      } catch (e) {
        this.cancelJob(report.jobId);
        throw e;
      }
    });
  }

  private pollAdminJobData(): void {
    this.activeJobs.forEach(async (report: any) => {
      try {
        if (report.pollData.type.startsWith('admin')) {
          const job = await JobsService.pollAdminJob(report.jobId);

          const currJob = {jobId: report.jobId, pollData: job};
          this.getCurrentJobValue(currJob);
          report.pollData = job;
          if (job.status === 'completed' || job.status === 'failed') {
            this.addCompletedJob(currJob);

            if (job.type.startsWith('device')) {
              if (this.hasPermission('device:read')) {
                EventBus.$emit('DevicesTable:LoadDevices');
              } else if (this.hasPermission('inventory:read')) {
                EventBus.$emit('InventoryDevicesTable:LoadDevices');
              }
            }
          }
        }
      } catch (e) {
        this.cancelJob(report.jobId);
        throw e;
      }
    });
  }

  // TODO: Component needs refactoring to be more universal
  private getCurrentJobValue(job: any) {
    let percentageComplete = 0;
    const isExport = job.pollData.type.split('_').includes('export');
    if (!isExport && Object.keys(job.pollData.data).length > 0) {
      const processed = job.pollData.data.skipped + job.pollData.data.imported;
      percentageComplete = processed / job.pollData.data.rows * 100;
    } else if (job.pollData.type === 'location_export') {
      percentageComplete = 75;
    }
    for (const j of this.activeJobs) {
      if (j.jobId === job.jobId) {
        Vue.set(j, 'percentageComplete', percentageComplete);
      }
    }
  }

  private getStatusColor(status: string) {
    switch (status) {
      case 'completed': return 'green--text';
      case 'failed': return 'red--text';
    }
  }

}
